import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="onboarding--copy-text"
export default class extends Controller {
  static targets = ["source", "button"]

  copy(event) {
    event.preventDefault()

    // If source contains structured items (e.g. backup codes), copy one per line
    const items = this.sourceTarget.querySelectorAll("[data-backup-codes-download-target='code']")
    const textToCopy =
      items.length > 0
        ? Array.from(items)
            .map((el) => el.textContent.trim())
            .join("\n")
        : this.sourceTarget.textContent.trim()
    const originalHTML = this.buttonTarget.innerHTML
    const successMessage = this.buttonTarget.dataset.copyTextSuccessValue

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        this.buttonTarget.innerHTML = successMessage

        setTimeout(() => {
          this.buttonTarget.innerHTML = originalHTML
        }, 2000)
      })
      .catch((err) => {
        console.error("Error copying text: ", err)
      })
  }
}
